import { useNavigate, useSearchParams } from 'react-router-dom'

import { ErrorScreen, Header } from '@paysense-india-services/elevate-web'

import { LOAN_DETAIL_API } from '@/constants/api'

import { useFetch } from '@/hooks/useFetch'

import PageLoader from '@/components/PageLoader'

import getLoanDetailComponent from '@/app/pages/LoanDetail/utils'

import styles from './page.module.scss'

const LoanDetailPage = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const loanId = searchParams.get('loanId')

  const {
    data: pageData,
    loading,
    error,
    apiRequest
  } = useFetch(`${LOAN_DETAIL_API}/${loanId}`, false, true)

  if (loading) {
    return <PageLoader isLoading={loading} />
  }
  if (error) {
    return (
      <ErrorScreen
        buttonText='Try again'
        description='Please try again or check back later. Maybe give your phone a nice slap? Hey, it works on the TV remote.'
        onButtonClick={apiRequest}
        title='Something went wrong'
      />
    )
  }

  return (
    <>
      <Header
        className='ew-bg-secondary ew-shadow-none'
        isBackButton={true}
        onBack={() => navigate(-1)}
        style={{ top: 0 }}
      />
      <div className={`${styles.container} ew-overflow-y-auto ew-pb-16`}>
        {pageData?.sections?.items?.map((section, index) => getLoanDetailComponent(section, index))}
      </div>
    </>
  )
}

export default LoanDetailPage
